/* Api methods to call /functions */

const getProjects = () => {
    return fetch('/.netlify/functions/projek').then((response) => {
      return response.json()
    }).catch((e) => {
      console.log("catch getProject()", e)    
      return "Error";
    })
}

const getBiodata = () => {
    return fetch(`/.netlify/functions/biodata`).then(response => {      
      return response.json()
    }).catch((e) => {
      console.log("catch getBiodata()", e)    
      return "[]";
    })
}

const getSkills = () => {
  return fetch(`/.netlify/functions/skills`).then(response => {      
    return response.json()
  }).catch((e) => {
    console.log("catch getSkills()", e)    
    return "[]";
  })
}

const getWorks = () => {
  return fetch(`/.netlify/functions/works`).then(response => {      
    return response.json()
  }).catch((e) => {
    console.log("catch getWorks()", e)    
    return "[]";
  })
}

// const getBiodata = (todoId, data) => {
//   return fetch(`/.netlify/functions/todos-update/${todoId}`, {
//     body: JSON.stringify(data),
//     method: 'POST'
//   }).then(response => {
//     return response.json()
//   })
// }

export default {
    getProjects: getProjects,
    getBiodata: getBiodata,
    getSkills: getSkills,
    getWorks: getWorks
}